import { ChangeDetectionStrategy, Component, ElementRef, Renderer2 } from '@angular/core';
import { FireAndFlowerDefaultCardStackContentViewModel } from './fire-and-flower-default-card-stack-content-view-model';
import { PrintCardContentComponent } from '../../shared/print-card-content.component';

@Component({
  selector: 'app-fire-and-flower-default-card-stack-content',
  templateUrl: './fire-and-flower-default-card-stack-content.component.html',
  styleUrls: ['./fire-and-flower-default-card-stack-content.component.scss'],
  providers: [FireAndFlowerDefaultCardStackContentViewModel],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class FireAndFlowerDefaultCardStackContentComponent extends PrintCardContentComponent {
  constructor(
    public override viewModel: FireAndFlowerDefaultCardStackContentViewModel,
    elementRef: ElementRef,
    renderer2: Renderer2
  ) {
    super(viewModel, elementRef, renderer2);
  }
}
